/**
 * Arten von CategoryType
 * 
 * [Public] in den Namen integrieren, wenn es öffentlich ist
 * (Wenn in den Einstellungen aktiviert werden alle ...Pubilc dann zu generalPublic).
 */
export enum CategoryTypeType {
   /**
    * Allgemine Art (wenn in den Einstellungen aktiviert).
    */
   general = "general",

   /**
    * Allgemine Art für die Öffentlichkeit (wenn in den Einstellungen aktiviert).
    */
   generalPublic = "generalPublic",

   /**
    * Art für clients.
    */
   client = "client",

   /**
    * Art für clients (öffentlich).
    */
   clientPublic = "clientPublic",

   /**
    * Art für events.
    */
   events = "events",

   /**
    * Art für events (öffentlich).
    */
   eventsPublic = "eventsPublic",

   /**
    * Art für rental.
    */
   rental = "rental",

   /**
    * Art für rental (öffentlich).
    */
   rentalPublic = "rentalPublic",
}

export const CategoryTypeTypeNames = {
   general: "Allgemein",
   generalPublic: "Allgemien (öffentlich)",
   client: "Personen",
   clientPublic: "Personen (öffentlich)",
   events: "Veranstaltungen",
   eventsPublic: "Veranstaltungen (öffentlich)",
   rental: "Verleih",
   rentalPublic: "Verlei (öffentlich)"
};

export function getCategoryTypeType(categoryTypeType: CategoryTypeType, useGeneral: boolean) {
   if(categoryTypeType && useGeneral) {
      let isPublic = categoryTypeType.toLowerCase().includes("public");

      return isPublic ? CategoryTypeType.generalPublic : CategoryTypeType.general;
   } else {
      return categoryTypeType;
   }
};